import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import { InventoryLevelsIllustration } from "@faire/retailer-visitor-shared/views/point-of-sale/landing-page/components/InventoryLevelsIllustration";
import { Section } from "@faire/retailer-visitor-shared/views/point-of-sale/landing-page/components/Section";
import { Column, Row } from "@faire/web--source/slate/Layout";
import { Spacer, getSpacing } from "@faire/web--source/slate/spacing";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { Typography } from "@faire/web--source/slate/Typography";
import { useViewport } from "@faire/web--source/ui/hooks/useViewport";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import React from "react";
import styled from "styled-components";
export var InventoryLevelsSection = function() {
    var isMobile = useViewport().isMobile;
    if (isMobile) {
        return /*#__PURE__*/ _jsxs(Section, {
            color: Core.surface.subdued,
            children: [
                /*#__PURE__*/ _jsx(Spacer, {
                    height: "7x"
                }),
                /*#__PURE__*/ _jsx(SectionHeading, {}),
                /*#__PURE__*/ _jsx(Spacer, {
                    height: "3x"
                }),
                /*#__PURE__*/ _jsx(SectionBody, {}),
                /*#__PURE__*/ _jsx(Spacer, {
                    height: "3x"
                }),
                /*#__PURE__*/ _jsx(InventoryLevelsIllustration, {}),
                /*#__PURE__*/ _jsx(Spacer, {
                    height: "7x"
                })
            ]
        });
    }
    return /*#__PURE__*/ _jsxs(Section, {
        color: Core.surface.subdued,
        children: [
            /*#__PURE__*/ _jsx(Spacer, {
                height: {
                    mobileAndAbove: "10x",
                    desktopAndAbove: 120
                }
            }),
            /*#__PURE__*/ _jsxs(Row, {
                justify: "space-between",
                children: [
                    /*#__PURE__*/ _jsx(IllustrationWrapper, {
                        children: /*#__PURE__*/ _jsx(InventoryLevelsIllustration, {})
                    }),
                    /*#__PURE__*/ _jsxs(SectionTextWrapper, {
                        justify: "center",
                        children: [
                            /*#__PURE__*/ _jsx(SectionHeading, {}),
                            /*#__PURE__*/ _jsx(Spacer, {
                                height: "5x"
                            }),
                            /*#__PURE__*/ _jsx(SectionBody, {})
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                height: {
                    mobileAndAbove: "10x",
                    desktopAndAbove: 120
                }
            })
        ]
    });
};
var SectionHeading = function() {
    return /*#__PURE__*/ _jsx(Typography, {
        variant: {
            mobileAndAbove: "displaySSerifRegular",
            tabletAndAbove: "displayMSerifRegular"
        },
        children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
            id: "EYGAh9",
            defaultMessage: [
                {
                    type: 0,
                    value: "Know what you have and when to reorder"
                }
            ]
        })
    });
};
var SectionBody = function() {
    return /*#__PURE__*/ _jsx(Typography, {
        variant: {
            mobileAndAbove: "paragraphSansRegular",
            tabletAndAbove: "subheadingSansRegular"
        },
        children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
            id: "wrcyfK",
            defaultMessage: [
                {
                    type: 0,
                    value: "See your current inventory levels when shopping on Faire so you can ensure your bestsellers are always in stock."
                }
            ]
        })
    });
};
var SectionTextWrapper = styled(Column).withConfig({
    componentId: "sc-8e3845cb-0"
})([
    "width:calc(50% - ",
    ");max-width:504px;",
    "{width:calc(50% - ",
    ");}"
], getSpacing("10x"), responsiveMediaQueries.tabletAndBelow, getSpacing("5x"));
var IllustrationWrapper = styled(Column).withConfig({
    componentId: "sc-8e3845cb-1"
})([
    "width:50%;max-width:584px;"
]);
